module.exports = __webpack_public_path__ + "media/images/lp_v6_03_sp-0252d67984d5de6afc6f3787908b64f4.webp";